import moment from 'moment/moment'

/**
 * Convert minutes to hours
 * @param time
 * @returns {*}
 */
export default function format_minutes_to_hours (time) {
  console.log('format_minutes_to_hours - time:', time)
  if (!(time > -1)) {
    return false
  }
  time = parseInt(time)

  if (time > (24 * 60)) {
    time = time - (24 * 60)
  }

  let duration = moment.duration(time, 'minutes')
  let padToTwo = number => number <= 99 ? ('0' + number).slice(-2) : number
  return padToTwo(duration.hours()) + ':' + padToTwo(duration.minutes())
}


// WEBPACK FOOTER //
// ./src/api/format_minutes_to_hours.js